import { cn, Logo } from "@nexxt/ui";
import { m } from "../../paraglide/messages.js";
import { vars } from "../css-vars";
import { useSceneTimeline } from "../motion/use-scene-timeline";

// Through the one door (ADR-286): a message leaves the outbox, crosses TIL to its system and a receipt comes back, or
// the other way; at the end Claude asks Nexxt through MCP.
const durations = [2400, 2400, 2400, 2400, 3600] as const;
const systems = ["Business Central", "IMS", "GXO", "Joor", "Zendesk"] as const;
const messages = [
  { system: 0, label: () => m.scene_outside_po(), inbound: false },
  { system: 1, label: () => m.scene_outside_stock(), inbound: true },
  { system: 2, label: () => m.scene_outside_shipment(), inbound: false },
  { system: 4, label: () => m.scene_outside_claim(), inbound: false },
] as const;

export function OutsideScene({ active, still }: { active: boolean; still: boolean }) {
  const step = useSceneTimeline(durations, active, still);
  const message = messages[step];
  return (
    <div aria-hidden className={cn("door", `is-step-${step}`)}>
      <div className="door-diagram">
        <div className="door-nexxt">
          <Logo variant="wordmark" className="h-3 w-auto" />
          <span className="door-caption">{m.scene_outside_outbox()}</span>
          <span className="door-stack">
            <i className="door-line" />
            <i className="door-line" />
            <i className="door-line" />
          </span>
        </div>
        <div className="door-til">TIL</div>
        <ul className="door-systems">
          {systems.map((system, i) => (
            <li key={system} className={cn("door-system", message?.system === i && "is-target")}>
              {system}
            </li>
          ))}
        </ul>
        {message && (
          <span
            key={step}
            className={cn("packet", message.inbound && "is-inbound")}
            style={vars({ "--row": message.system })}
          >
            {message.label()}
          </span>
        )}
        {message && (
          <span key={`receipt-${step}`} className={cn("receipt", message.inbound && "is-inbound")}>
            ✓ {m.scene_outside_receipt()}
          </span>
        )}
      </div>
      <div className={cn("claude-card", step === 4 && "is-shown")}>
        <p className="claude-ask">{m.scene_outside_question()}</p>
        <p className="claude-answer">
          <span className="claude-tag">Claude · MCP</span>
          {m.scene_outside_answer()}
        </p>
      </div>
    </div>
  );
}
